import { z } from 'zod';

import i18n from '@/lib/i18n/i18n';

const { t } = i18n;

export const askToJoinValidationSchema = z.object({
  firstName: z
    .string()
    .nonempty(t`ask-to-join:validation.firstName.required`)
    .min(3, t`ask-to-join:validation.firstName.minLength`),
  lastName: z
    .string()
    .nonempty(t`ask-to-join:validation.lastName.required`)
    .min(3, t`ask-to-join:validation.lastName.minLength`),
  email: z
    .string()
    .nonempty(t`ask-to-join:validation.email.required`)
    .email(t`ask-to-join:validation.email.invalid`),
  position: z
    .string()
    .nonempty(t`ask-to-join:validation.position.required`)
    .min(3, t`ask-to-join:validation.position.minLength`),
  note: z.string().optional(),
});
